import { Fragment } from 'react';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { STATUS_LABEL, STATUS_VARIANT } from '@/lib/format';
import type { AccountStatus } from '@/lib/types';

/**
 * Pipeline visual do fluxo de compra (Q-246):
 * Disponível → Com saldo → Jogo comprado → Importada / Em uso.
 * Etapa atual sólida (variant do status), passadas com opacidade, futuras muted.
 * Status fora do pipeline (banida, suspensa…) caem num Badge único.
 */
const PIPELINE: AccountStatus[] = ['available', 'funded', 'game_purchased', 'in_use'];

export function AccountPipeline({ status }: { status: AccountStatus }) {
  const idx = PIPELINE.indexOf(status);

  if (idx === -1) {
    return <Badge variant={STATUS_VARIANT[status]}>{STATUS_LABEL[status]}</Badge>;
  }

  return (
    <div className="flex flex-wrap items-center gap-2" aria-label="Etapa da conta no fluxo de compra">
      {PIPELINE.map((s, i) => (
        <Fragment key={s}>
          {i > 0 && <Separator className="w-4" />}
          <Badge
            variant={i === idx ? STATUS_VARIANT[s] : i < idx ? STATUS_VARIANT[s] : 'muted'}
            className={i === idx ? '' : i < idx ? 'opacity-40' : 'opacity-60'}
          >
            {STATUS_LABEL[s]}
          </Badge>
        </Fragment>
      ))}
    </div>
  );
}
